<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	// Stores
	import SportStore from '@/Stores/Sport/SportStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	// Services
	import { getUrlParameter, setUrlParameter } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Partials
	import FeaturedCompetitions from '@/Partials/Sport/Manage/Competitions/_Featured.svelte';
	import CompetitionTiers from '@/Partials/Sport/Manage/Competitions/_Tiers.svelte';

	export let action;

	const actionMap = {
		featured: {
			title: 'Featured Competitions',
			component: FeaturedCompetitions,
			read_permission: 'competitions.update',
			slug: 'featured'
		},
		tiers: {
			title: 'Competition Tiers',
			component: CompetitionTiers,
			read_permission: 'competitions.update',
			slug: 'tiers'
		}
	};

	$: sportId && setUrlParameter('sport_id', sportId);

	let sportId = parseInt(getUrlParameter('sport_id')) ?? null;
	let loading = SportStore.getSports(true);
</script>

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center justify-between w-full">
					<h1 class="text-xl font-bold">{actionMap[action].title}</h1>
					<div class="flex-1 text-center">
						<div class="btn-group">
							{#each Object.keys(actionMap) as item}
								{#if $ACLStore && ACLStore.granted(actionMap[item].read_permission)}
									<Link
										href={`/sport/competitions/${actionMap[item].slug}`}
										class="btn {item === action ? 'btn-primary-action' : 'btn-muted text-dark'}"
									>
										{actionMap[item].title}
									</Link>
								{/if}
							{/each}
						</div>
					</div>
				</div>
			</div>
			<!-- /Page Header -->
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<div class="flex items-center justify-between">
					<SelectInput className="py-1 w-1/3" name="sport" required={true} bind:value={sportId}>
						<option value={false}>Select Sport...</option>
						{#each $SportStore.sortBy('name').all() as sport (sport.id)}
							{#if sport.id === parseInt(sportId)}
								<option value={sport.id} selected>{sport.name}</option>
							{:else}
								<option value={sport.id}>{sport.name}</option>
							{/if}
						{/each}
					</SelectInput>
				</div>
				{#if sportId}
					<!-- ACTION COMPONENT -->
					<svelte:component this={actionMap[action].component} {sportId} />
				{/if}
			</div>
		</div>
	{/await}
</div>
